<template>
  <div class="full">
    <transition mode="out-in" :name="transition" :duration="{ enter: 150, leave: 50 }" @after-leave="debounce">
      <keep-alive include="dashboard">
        <router-view :key="$store.state.user.affiliate_id" :affiliate="$store.state.user.affiliate_id"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
const debounce = require('debounce');

export default {
  data() {
    return {
      transition: 'rotator-fade',
      debounce: debounce(() => this.transition = 'rotator-fade', 300)
    }
  },
  watch: {
    '$store.state.user.affiliate_id'() {
      this.transition = ''
    }
  }
}
</script>
<style lang="scss">
@import '~static/mixins/global';
@import '~static/mixins/variables';
@import '~static/theme/display';

* {
  box-sizing: border-box;
}

body,
html,
body > .full,
.main{
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: fixed;
}
h1, h2, h3 {
  font-weight: normal;
  text-align: left;
}

p {
  text-align: left;
}

ul {
  list-style-type: none;
  padding: 0;
}

.el-loading-spinner .path{
  fill: none;
}
.el-loading-mask{
  background-color: transparent;
}

.input-holder .el-loading-spinner .circular{
  width: 32px;
  height: 32px;
  position: relative;
  top: 4px;
}
.input-holder .el-loading-spinner .path{
  stroke: #fff;
}

.scale-enter-active {
  transition: all .2s;
  transform: scale(1);
}
.scale-leave-active {
  transition: all .2s;
}
.scale-enter, .scale-leave-to{
  opacity: 0;
  transform: scale(.3);
}
.browserupgrade {
  text-align: center;
}

.el-tooltip__popper {
  position: absolute;
  border-radius: 4px;
  padding: 10px;
  z-index: 2000;
  font-size: 12px;
  line-height: 1.2;
  font-family: 'Questrial', Arial, sans-serif;
}
.rotator-fade-enter-active, .rotator-fade-leave-active {
  transition: opacity .15s;
}
.rotator-fade-leave-to  {
  opacity: 0
}
.rotator-fade-enter{
  opacity: 0
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
.list-enter {
  opacity: 0;
  transform: translateY(30px);
}
.list-leave-to {
  opacity: 0;
}
.list-leave-active {
  position: absolute;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.particles-js-canvas-el {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

/*====
 *
 ** TOOL FORM ELEMENTS
 *
   ====*/
.btn__default{
 margin: 10px 0;
 background: $blue;
 border: none;
 color: $white;
 padding: 15px;
 cursor: pointer;
 position: relative;
 top: 0;
 border-radius: 0;
 display: inline-block;
 vertical-align: middle;
 text-transform: uppercase;
 box-shadow: 0 2px 3px 0px rgba(0, 0, 0, 0.3);
 transition: all .2s ease-out;

 &:hover{
   box-shadow: 0 3px 8px 2px rgba(0,0,0, .2);
   background: #3199fc;
   top: -4px;
 }
}
.el-card__body{
  padding: 0;
  &:after{
    content: '';
    display: block;
    clear: both;
  }
}

.data-holder .el-input__icon + .el-input__inner{
  border: none !important;
  color: #000;
}
.input__default .el-input__inner,
.input__default .el-input__icon +  .el-input__inner {
  width: 100%;
  height: 20px;
  padding: 10px 3px;
  border-radius: 0;
  background: transparent;
  background-color: transparent;
  color: #000 !important;

  @include borderBundle(none, none, 1px solid #ccc, none);

}
.select__default .el-input__icon +  .el-input__inner{
  background: transparent !important;
  background-color: transparent !important;
  text-transform: capitalize;
}


.input__default .el-input__icon +  .el-input__inner {
  border: none !important;
}
.input__default .el-input__icon +  .el-input__inner::-webkit-input-placeholder{
  color: #000;
}
.input__default .el-input__icon +  .el-input__inner::-moz-placeholder{
  color: #000;
}
.input__default .el-input__icon +  .el-input__inner:-ms-input-placeholder{
  color: #000;
}
.input__default .el-input__icon +  .el-input__inner:-moz-placeholder{
  color: #000;
}

/*====
 *
 ** SEARCHBAR
 *
   ====*/

.searchbar
{ /*Seachbar*/
  .el-input,
  .el-input__inner {
    height: 26px;
  }
  input[type="text"]{
    font-size: 13px;
    width: 100%;
    border-radius: 30px;
    border: none;
    color: #333;
    background: #fff;
    padding: 5px 15px;
    transition: width .3s;
  }
  ::-webkit-input-placeholder {
    color: #333 !important;
  }
}
.panels
{ /*Panels*/
  transition: all .3s;

  .panel-select
  { /*Panel Select*/
    background-color: #054465;
    border: 1px solid #02324c;

    .el-select-dropdown__item.hover{
      background-color: #023854;
    }
    .el-select-dropdown__item.selected{
      background-color: #21698e;
    }
    .el-select-dropdown__item{
      color: #fff;
    }
  }
  .panel-item
  { /*Panel Item*/
    border-bottom: 1px solid #043a54;
    overflow: hidden;
    padding: 15px 0 15px 0;
    position: relative;
    transition: background-color .3s;
    background: none;

    &:hover {
      background: #F6F9F9;

      .add-rotator-button-container .el-button{
        box-shadow: 0 3px 10px 2px rgba(37,37,37, .5);
      }
    }
    &.active {
      background: #fff;
    }
    &:hover,
    &.active{
      cursor: pointer;
      .el-button{
          color: #111;
      }
      p,
      .affiliate_id{
        color: #000 !important;
      }
    }
    p{
      font-size: 13px;
      line-height: 19px;
      color: #f1f1f1;
      font-weight: 100;
      transition: color .2s;
    }
    p.unpaired:first-child{
      font-size: 15px;
      height: 43px;
      line-height: 43px;
      color: #ddd;
    }
    p span{
      display: block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .list-item{
      padding: 10px 15px 4px 15px;
      position: relative;
    }

    .add-rotator-button-container{
      transition: .3s all;
      overflow: hidden;

      .panel-placeholder{
        transition: all .3s;
        filter: blur(2px);

        .placeholder-header{
          height: 15px;
          background: #fafafa;
          width: 75px;
          opacity: .5;
          transition: all .3s;
          margin-bottom: 10px;
        }
        .placeholder-item{
          height: 13px;
          background: #fafafa;
          opacity: .5;
          transition: all .3s;
          margin-bottom: 10px;

          &:nth-child(2n+1){
            width: 105px;
          }
          &:nth-child(2n+2){
            width: 175px;
          }
          &:nth-child(2n+3){
            width: 205px;
          }
        }
      }
      .el-button{
        position: absolute;
        margin: auto;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 10;
        transition: .3s all;
        width: calc(100% - 150px);
        height: 40px;
        line-height: calc(20%);
        background: #fff;
        color: #111;
      }
    }
  }
  .filter-holder
  { /*Filter Holder*/
  	padding: 0;
   	background: #023854;
    height: 50px;

    .el-input__inner{
      background-color: #054465;
      border: 1px solid #02324c;
      color: #fff;
    }
    .select {
      padding: 5px 15px;
      height: 60px;

      .el-select {
        width: 48%;
        &:first-child {
          float: right;
        }
        &:last-child {
          float: left;
        }
      }
    }
    .filter{
      margin-bottom: 10px;

      select{
        width: 100%;
      }
    }
  }
}
.column__default{
  .el-select{
    width: 100%;
  }
}
.el-date-editor .el-range__close-icon{
  width: 10px;
}
/*====
 *
 ** TOOLTIP STYLE OVERWRITE
 *
   ====*/

.el-tooltip__popper.affiliate-overage {
  width: 370px;
  text-align: center;
}
.campaign-headers{
  margin: 0 0 20px 0;
  height: 40px;
}
.error-bar {
  margin-bottom: 20px;
}

/*====
 *
 ** DATA HOLDER
 *
   ====*/
#line-chart{
  height: 400px !important;
}
.data-holder
{ /*Data Holder*/
  height: inherit;
  background: #f9f9f9;
  top: 0;
  right: -100%;
  z-index: 22;
  position: fixed;
  overflow: hidden;
  transition: right .5s ease-out;
  width: 90%;

  .el-input__icon + .el-input__inner{
    color: #fff;
    background-color: #0085c1;
    border: 1px solid #107aab;
  }
  .el-input__icon {
    color: #64b6dc;
  }

  .data-holder-inner,
  .filter-holder{
    width: 100%;
  }
  .filter-holder
  { /*Filter Holder*/
    z-index: 10;
    height: 50px;
    background: linear-gradient(140deg, #007ED1, #008CD6);

    .filter{
      padding: 5px 20px;
      select{
        color: #ffffff;
        width: 100%;
      }
    }
  }
}
.rotator-controls-info,
.performance-charts{
  .el-collapse{
    border: none;
  }
  .el-collapse-item__arrow {
    margin-right: 15px;
  }
  .el-collapse button {
    float: right;
    margin-right: 15px;
    margin-left: 0px;
    position: relative;
    top: 6px;
  }
  .el-collapse button.ml {
    padding: 0;
    float: none;
    position: relative;
    top: -3px;
    margin-left: 10px;
    margin-right: 0px;

    > * {
      display: block;
      > * {
        padding: 7px 20px;
        height: auto;
      }
    }
  }
  .el-collapse-item__header{
    background-color: rgba(161, 192, 208, .3);
    border: none;
    font-size: 17px;
    margin-bottom: 6px;
    padding: 0 0 0 15px;
    box-shadow: 0 1px 1px 0 rgba(0,0,0, .3);
    font-family: $font-family-interface;
    position: relative;
    .required-field{
      position: absolute;
      right: 45px;
      top: 0px;
    }
  }
  .el-collapse-item__wrap{
    background-color: transparent;
  }
}
.new-rotator-select-container{
  padding: 20px 15px;
  background: #fff;
  box-shadow: 0 1px 1px 0px rgba(0,0,0,.3) !important;
  margin-bottom: 35px;
  position: relative;

  .headerone__default{
    margin-bottom: 7px !important;
    .bold__optional{
      width: 100px;
      display: inline-block;
    }
  }
}
.tracking-link-container__default{
  padding: 10px 0;
  .el-input{
    margin: 10px 0 0 0;
  }
  .el-input__inner{
    border: none;
    border-bottom: 1px solid #ccc;
    padding-left: 0px;
    font-weight: lighter;
    border-radius: 0;
    padding-right: 165px;
  }
}

.slidein
{ /*Slide In*/
  /*background: white;*/
  background: #f9f9f9;
  position: relative;
  top: 0;
  width: 100%;
  right: 0;
  height: inherit;
  transition: right .3s;
  padding-bottom: 50px;


  .content {
    width: 100%;
    margin: 0 auto;
    position: relative;
  }

  .data-content{
    padding: 32px 32px 75px 32px;
  }
  .el-range-editor.el-input__inner{
    margin-bottom: 25px;
  }
}
@media (hover:none), (hover:on-demand) {
  .panels .panel-item:hover:not(.active) {
    background: none !important;

    p,
    .affiliate_id,
    .el-button {
      color: #f1f1f1 !important;
    }
  }
}

@media(max-width: 736px){
  .el-collapse-item__header{
    height: auto;
  }
  .rotator-controls-info .el-collapse button, .performance-charts .el-collapse button{
    float: right;
    top: 7px;
  }
  .rotator-controls-info .el-collapse button.ml, .performance-charts .el-collapse button.ml{
    margin-left: 0;
    top: -3px;
  }
}
@media(min-width: 1024px){
  .data-holder{
    right: 0 !important;
    position: relative;
    margin-left: 375px !important;
    width: auto;
  }
}
/*====
 *
 ** RESPONSIVE
 *
   ====*/

@media(max-width: 767px) {
  .el-message-box {
    max-width: 420px;
    width: 100%;
  }
  .slidein.data-content {
    padding: 16px 16px 75px 16px;
  }
  .new-rotator-select-container {
    margin-bottom: 32px;
    padding: 15px 24px;
  }
  .el-collapse-item__content {
    padding-bottom: 32px;
  }
  .el-date-range-picker.has-sidebar {
    width: 365px !important;
    min-width: 365px !important;
  }
  .el-picker-panel__body, .el-date-range-picker .el-picker-panel__body {
    width: 254px !important;
    min-width: 254px !important;
  }
  .el-picker-panel__icon-btn {
    padding-left: 6px;
    padding-right: 6px;
  }
  .el-date-range-picker__header div {
    white-space: nowrap;
    overflow: hidden;
  }
  .el-date-range-picker__content {
    padding: 8px;
  }
  .el-date-range-picker__content.is-right {
    width: 0;
    margin: 0;
    padding: 0;
  }
  .el-date-range-picker__content.is-left {
    width: 100%;
  }
  .el-date-range-picker__content.is-right table {
    display: none;
  }
  .el-date-range-picker__content.is-right .el-date-range-picker__header {
    position: absolute;
    left: -70px;
    top:8px;
    display: block;
    width: 60px;
  }
  .el-date-range-picker__content.is-right .el-date-range-picker__header > div {
    display: none;
  }
  .el-dialog--small {
    width: 90%;
  }
}
.el-message{
  font-family: $font-family-interface;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.2), 1px 0px 1px -1px rgba(0, 0, 0, 0.2), -1px 0px 1px -1px rgba(0, 0, 0, 0.2);

  &.el-message--warning{
    background: #fdcccc;
    border: 1px solid #f62121;
    .el-message__content,
    .el-icon-warning{
      color: #f62121;
    }
  }

  &.el-message--success{
    background: #c5f1ff;
    border: 1px solid #ADD8E6;
    .el-message__content,
    .el-icon-success{
      color: #3c7183;
    }
  }
}
/*el-message--success is-center jbo-message*/
@media(min-width: 768px){
  .data-active .data-holder {
    z-index: 260;
  }
}
@media(min-width: 1024px){
  .data-active .data-holder {
    z-index: 22;
  }
}
@media(min-width: 1199px){
  .data-active .slidein{
 	right: 0;
  }
}
@media (min-width: 1600px){
  .slidein{
    .content {
      width: 960px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?3df8cd5e